export function DisableStickyHeader() {
    new CustomEvent('disable-sticky-header');
}

export function EnableStickyHeader() {
    new CustomEvent('enable-sticky-header');
}

export function ShowStickyHeader() {
    new CustomEvent('show-sticky-header');
}

export function DiagramStickyHeader() {
    //$('#container').css('marginTop', $('.js-sticky-header').outerHeight());

    var Diagram = {};
	Diagram.StickyHeader = [];
    Diagram.StickyHeader.$header = $('.js-normal-header');
    Diagram.StickyHeader.$navbar = $('.js-sticky-header');
    Diagram.StickyHeader.headerHeight = 0;
    Diagram.StickyHeader.enabled = true;

	Diagram.StickyHeader.showNavBar = function () {
		Diagram.StickyHeader.$header.removeClass('nav-up').addClass('nav-down');
    };

    Diagram.StickyHeader.hideNavBar = function () {
        Diagram.StickyHeader.$header.removeClass('nav-down').addClass('nav-up');
    };

    Diagram.StickyHeader.hasScrolled = function () {
        if (Diagram.StickyHeader.enabled) {
            var st = $(document).scrollTop();

            // If they scrolled down and are past the navbar, add class .nav-up.
            if (st > Diagram.StickyHeader.headerHeight) {
                // Scroll Down
                Diagram.StickyHeader.hideNavBar();
            } else {
                // Scroll Up
                Diagram.StickyHeader.showNavBar();
            }
        }
	}

	Diagram.StickyHeader.init = function () {
        if (Diagram.StickyHeader.$navbar.length > 0) {
            Diagram.StickyHeader.headerHeight = Diagram.StickyHeader.$header.outerHeight();

            $(window).on("scroll", Diagram.StickyHeader.hasScrolled);

			document.addEventListener('disable-sticky-header', function () {
				Diagram.StickyHeader.enabled = false;
			});

			document.addEventListener('show-sticky-header', function () {
				Diagram.StickyHeader.showNavBar();
			});

			document.addEventListener('enable-sticky-header', function () {
				Diagram.StickyHeader.enabled = true;
			});
		}
	}

	Diagram.StickyHeader.init();
}